<script setup lang="ts">
import ModalPrivacyPolicy from '@/components/modals/modal-privacy-policy.vue';
import { onMounted, watch } from 'vue';
import { useModal } from 'bootstrap-vue-next';
import {storeToRefs} from 'pinia';
import {useUserStore} from "@/store/user";

const userStore = useUserStore();
const policyModal = useModal('modal-privacy-policy');
const { user } = storeToRefs(userStore);

const showPolicyModal = () => {
	if (user.value?.term_of_use === false) {
		policyModal.show();
	}
};
const showUserActualModal = () => {
	const { id, term_of_use } = user.value || {};

	if (!id) {
		return false;
	}

	if (!term_of_use) {
		showPolicyModal();
	}
}

watch(user, () => {
	showUserActualModal();
})

onMounted(() => {
	showUserActualModal();
});
</script>

<template>
	<div>
		<modal-privacy-policy />
	</div>
</template>
